// extracted by mini-css-extract-plugin
export var blue = "button-module--blue--ChgvE";
export var green = "button-module--green--V6+bR";
export var inner = "button-module--inner--avh7V";
export var md = "button-module--md--Ssu-T";
export var root = "button-module--root--fXkPh";
export var sm = "button-module--sm--WpoJ2";
export var transparent = "button-module--transparent--j3yFb";
export var widthFill = "button-module--width-fill--CIOnE";
export var widthMd = "button-module--width-md--LENRb";